import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { UploadInput } from 'ngx-uploader';
import { Globals } from '../helpers';
import { HttpInterceptor } from './http-error.interceptor';

@Injectable()
export class StructuredService {
  private url: string;

  constructor(private http: HttpInterceptor, private globals: Globals) {
    this.url = globals.url + 'structured/';
  }

  public getContent(contentId: string) {
    return this.http.get(this.url + contentId).map((response: Response) => response.json());
  }
  public updateContent(contentId: string, update) {
    return this.http.put(this.url + contentId, update).map((response: Response) => response.json());
  }
  public deleteContent(contentId: string, deleteContentRecursive?: boolean) {
    let urlaux = this.url + contentId;
    if (deleteContentRecursive) { urlaux += '?deleteContentRecursive=' + deleteContentRecursive; }
    return this.http.delete(urlaux).map((response: Response) => response.json());
  }
  public getBreadcrumb(contentId: string) {
    return this.http.get(this.url + contentId + '/breadcrumb').map((response: Response) => response.json());
  }
  public getNodes(contentId: string, filters?) {
    let urlMod = this.url + contentId + '/nodes';
    const params: URLSearchParams = new URLSearchParams();
    if (filters && Object.keys(filters).length !== 0 && filters.constructor === Object) {
      Object.keys(filters).forEach((filter) => {
        params.set(filter, filters[filter] + '');
      });
    }
    const paramsStr = params.toString();
    if (paramsStr) { urlMod += '?' + paramsStr; }
    return this.http.get(urlMod).map((response: Response) => response.json());
  }
  public createNode(contentId: string, node) {
    return this.http.post(this.url + contentId + '/nodes', node).map((response: Response) => response.json());
  }
  public uploadFile(contentId: string, fullPaths?) {
    const event: UploadInput = {
      url: this.url + contentId + '/upload',
      method: 'POST',
      type: 'uploadAll',
      headers: this.http.jwt(),
    };
    if (fullPaths) { event.data = fullPaths; }
    return event;
  }
  public uploadZip(contentId: string, fullPaths?) {
    const event: UploadInput = {
      url: this.url + contentId + '/upload-zip',
      method: 'POST',
      type: 'uploadAll',
      headers: this.http.jwt(),
    };
    if (fullPaths) { event.data = fullPaths; }
    return event;
  }

  public deleteGeneric(type, id) {
    return this.http.delete(this.url + 'generic?type=' + type + '&id=' + id).map((response: Response) => response.json());
  }
  public createGeneric(payload) {
    return this.http.post(this.url + 'generic', payload).map((response: Response) => response.json());
  }
  public getGenericFilters() {
    return this.http.get(this.url + 'generic/all').map((response: Response) => response.json());
  }
  public getSubjects() {
    return this.http.get(this.url + 'generic?type=subject').map((response: Response) => response.json());
  }
  public getGrades() {
    return this.http.get(this.url + 'generic?type=grade').map((response: Response) => response.json());
  }
  public getTags() {
    return this.http.get(this.url + 'generic/tags').map((response: Response) => response.json());
  }
  public getContentTags(nodeId) {
    return this.http.get(this.url + nodeId + '/filters').map((response: Response) => response.json());
  }
  public move(contentId: string, parentId: string) {
    return this.http.put(this.url + contentId, { parentId }).map((response: Response) => response.json());
  }
  public getContentFolders(contentId: string) {
    return this.http.get(this.url + contentId + '/folders').map((response: Response) => response.json());
  }
  // Thumbnail
  public putThumbnail(contentId: string) {
    const event: UploadInput = {
      method: 'PUT',
      url: this.url + contentId + '/thumbnail',
      type: 'uploadAll',
      headers: this.http.jwt(),
    };
    return event;
  }
  public deleteThumbnail(contentId: string) {
    return this.http.delete(this.url + contentId + '/thumbnail').map((response: Response) => response.json());
  }

  // Youtube
  public checkURLs(urls, currentDir) {
    return this.http.put(this.url + 'youtube', { urls, currentDir }).map((response: Response) => response.json());
  }
  public downloadURL(contentId, currentDir, url, info) {
    return this.http.post(this.url + contentId + '/nodes/youtube', { currentDir, url, info }).map((response: Response) => response.json());
  }
  public resumeDownload(contentId) {
    return this.http.put(this.url + contentId + '/nodes/youtube', { contentId }).map((response: Response) => response.json());
  }
}
